import React from 'react';

import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import cn from 'classnames';

import { Button } from 'modules/common/input';

import { PAYMENT_OPTS_ROUTES } from '../../pos-management/Routes';

function PaymentMethodModal({
  parentClose,
  parentMatch,
  onClose,
  isProcessingInModal,
  cartTotal,
  branch,
  onSuccess,
  data,
  settings,
  subtotal,
  onPay,
}) {
  const [paymentMethod, setPaymentMethod] = React.useState('');
  const history = useHistory();

  const handleOnClick = (row) => () => {
    if (isProcessingInModal) {
      setPaymentMethod(row);
      return;
    }

    history.push({
      pathname: `${parentMatch?.url}${row?.to}`,
      state: {
        cartTotal,
        subtotal,
      },
    });
    const width = window.innerWidth;
    if (width <= 767) {
      onPay();
    }
    onClose();
    parentClose();
  };

  if (paymentMethod) {
    return (
      <div className="!mt-[-35px]">
        <paymentMethod.component
          withGoBack
          onGoBack={onClose}
          onParentClose={parentClose}
          data={data}
          cartTotal={cartTotal}
          branch={branch}
          onSuccess={onSuccess}
          isProcessingInModal={isProcessingInModal}
          setPaymentMethod={setPaymentMethod}
          state={paymentMethod?.state || {}}
          settings={settings}
        />
      </div>
    );
  }

  return (
    <div>
      {isProcessingInModal && (
        <div className="flex items-center mb-3">
          <div className="text-lg md:text-xl text-black font-bold">
            Select Payment Method
          </div>

          <div className="ml-auto">
            <button
              type="button"
              tabIndex="-1"
              className="rounded-full transition duration-300 ease-in-out group outline-none group hover:bg-primary-500 p-1"
              onClick={onClose}
            >
              <svg
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                className="w-6 h-6 transition duration-300 ease-in-out group-hover:text-white text-primary-500 rounded-full"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="4"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
        </div>
      )}

      <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
        {PAYMENT_OPTS_ROUTES?.map((item) => (
          <Button
            key={item?.key}
            onClick={handleOnClick(item)}
            label={
              <div className="flex-1 card flex flex-col has-tooltip relative">
                <div
                  className={cn('flex flex-col flex-1 gap-2 md:gap-3.5', {
                    '!opacity-40': !item?.module_permission,
                  })}
                >
                  <div className="h-20 md:h-24 w-20 md:w-24 bg-primary-50 rounded-full flex mx-auto">
                    <div className="m-auto">
                      <item.icon className="h-20 md:h-24 w-20 md:w-24 text-primary-500 p-2 rotate-12" />
                    </div>
                  </div>
                  <div className="text-center capitalize text-sm font-medium">
                    {item?.name}
                  </div>
                </div>

                {!item?.module_permission && (
                  <span className="tooltip visible rounded shadow-lg p-2 px-2.5 bg-gray-900 bg-opacity-80 text-white text-xs text-left absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-28 md:w-40">
                    This feature is currently unavailable.
                  </span>
                )}
              </div>
            }
            disabled={!item?.module_permission}
          />
        ))}
      </div>
    </div>
  );
}

PaymentMethodModal.defaultProps = {
  parentMatch: {},
  settings: {},
  branch: {},
  data: {},
  parentClose: () => {},
  onSuccess: () => {},
  onClose: () => {},
  onPay: () => {},
  isProcessingInModal: false,
  cartTotal: null,
  subtotal: 0,
};

PaymentMethodModal.propTypes = {
  parentMatch: PropTypes.instanceOf(Object),
  settings: PropTypes.instanceOf(Object),
  branch: PropTypes.instanceOf(Object),
  data: PropTypes.instanceOf(Object),
  onClose: PropTypes.instanceOf(Function),
  onSuccess: PropTypes.instanceOf(Function),
  parentClose: PropTypes.instanceOf(Function),
  onPay: PropTypes.instanceOf(Function),
  isProcessingInModal: PropTypes.bool,
  cartTotal: PropTypes.number,
  subtotal: PropTypes.number,
};

export default PaymentMethodModal;
